import { render, staticRenderFns } from "./treasuryDocSkeleton.vue?vue&type=template&id=e83b5134&scoped=true"
import script from "./treasuryDocSkeleton.vue?vue&type=script&lang=js"
export * from "./treasuryDocSkeleton.vue?vue&type=script&lang=js"
import style0 from "./treasuryDocSkeleton.vue?vue&type=style&index=0&id=e83b5134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83b5134",
  null
  
)

export default component.exports